
        var result = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/lib/loader.js!./deleted-vapps.scss");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./src/app/components/dataprotection/dataprotection-vcd/deleted-vapps/deleted-vapps.scss
// module id = +0Uo
// module chunks = 0